import { render, staticRenderFns } from "./o-add-resource.vue?vue&type=template&id=161266da&"
import script from "./o-add-resource.vue?vue&type=script&lang=js&"
export * from "./o-add-resource.vue?vue&type=script&lang=js&"
import style0 from "./o-add-resource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports